import { v4 as uuidv4 } from "uuid";
let inc = 0;

export const uid = () => "" + inc++;
export const uuid = () => uuidv4();
